// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-divider[data-v-9a76ca26] {\n  border-radius: 4px;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n  border-top: var(--d-weight) var(--d-style) var(--d-color);\n  width: var(--d-width);\n}", ""]);
// Exports
module.exports = exports;
